import "./Application.css";
import leanApp1 from "../../slike/leanApp.png";
import karakurApp1 from "../../slike/karakuriApp.jpg";
import leanApp3 from "../../slike/leanApp3.jpg";
import karakuri3 from "../../slike/karakuri3.png";
import leantube4 from "../../slike/leantube4.png";
import karakuri4 from "../../slike/karakuri4.png";
import aluminium1 from "../../slike/aluminiumprofiles1.png";
import heavysquare2 from "../../slike/heavysquare2.jpg";
import aluminium3 from "../../slike/aluminium3.png";
import heavysquare3 from "../../slike/heavysquare3.png";
import heavysquare4 from "../../slike/heavysquare4.png";
import aluminium4 from "../../slike/square4.jpg";
import sq8 from "../../slike/square8.png";
import l from "../../slike/l.png";
import leantubeApp from "../../slike/leantubeApp.jpg";
import leantubeApp2 from "../../slike/leantubeApp2.jpg";
import leantubeApp3 from "../../slike/leantubeApp3.jpg";
import leantubeApp5 from "../../slike/leantubeApp5.jpg";
import leantubeApp6 from "../../slike/leantubeApp6.jpg";
import leantubeApp7 from "../../slike/leantubeApp7.jpg";
import hs3 from "../../slike/hs3.jpg";
import hs4 from "../../slike/hs4.jpg";
import hs5 from "../../slike/hs5.jpg";
import hs6 from "../../slike/hs6.jpg";
import hs7 from "../../slike/hs7.jpg";
export default function Application() {
      const karakuriApp=[
        {slika:karakurApp1,naslov:"KARAKURI SYSTEM",link:"/"},
        {slika:leanApp3,naslov:"KARAKURI SYSTEM",link:"/"},
        {slika:karakuri3,naslov:"KARAKURI SYSTEM",link:"/"},
        {slika:karakuri4,naslov:"KARAKURI SYSTEM",link:"/"},
      ]
      const squareApp = [
        {slika:sq8,naslov:"SQUARE PROFILES",link:"/"},
        {slika:aluminium3,naslov:"SQUARE PROFILES",link:"/"},
        {slika:aluminium4,naslov:"SQUARE PROFILES",link:"/"},
        {slika:heavysquare2,naslov:"SQUARE PROFILES",link:"/"},
      ]
      const leanPipe = [
        {slika:leanApp1,naslov:"LEAN TUBE SYSTEM",link:"/"},
        {slika:aluminium1,naslov:"LEAN TUBE SYSTEM",link:"/"},
        {slika:l,naslov:"LEAN TUBE SYSTEM",link:"/"},
        {slika:leantube4,naslov:"LEAN TUBE SYSTEM",link:"/"},
        {slika:leantubeApp,naslov:"LEAN TUBE SYSTEM",link:"/"},
        {slika:leantubeApp2,naslov:"LEAN TUBE SYSTEM",link:"/"},
        {slika:leantubeApp3,naslov:"LEAN TUBE SYSTEM",link:"/"},
        {slika:leantubeApp5,naslov:"LEAN TUBE SYSTEM",link:"/"},
        {slika:leantubeApp6,naslov:"LEAN TUBE SYSTEM",link:"/"},
        {slika:leantubeApp7,naslov:"LEAN TUBE SYSTEM",link:"/"},
      ]
      const HeavySquare=[
        {slika:heavysquare3,naslov:"HEAVY SQUARE TUBE SYSTEM",link:"/"},
        {slika:heavysquare4,naslov:"HEAVY SQUARE TUBE SYSTEM",link:"/"},
        {slika:hs3,naslov:"HEAVY SQUARE TUBE SYSTEM",link:"/"},
        {slika:hs4,naslov:"HEAVY SQUARE TUBE SYSTEM",link:"/"},
        {slika:hs5,naslov:"HEAVY SQUARE TUBE SYSTEM",link:"/"},
        {slika:hs6,naslov:"HEAVY SQUARE TUBE SYSTEM",link:"/"},
        {slika:hs7,naslov:"HEAVY SQUARE TUBE SYSTEM",link:"/"}
      ]
  return (
    <div className='applicationPage'>
        <div className='homeC'>
          <p>Applications</p>
      </div>
      <div className='productsContainer'>
        <p className='h2' style={{fontFamily:"Exo2-Medium"}} >Karakuri Pipe Applications</p>
      </div>
      <div className='sA'>
        {karakuriApp.map((item,index)=>(
            <div className='okvirA' style={{marginRight:"3%"}}>
              <div className='productBoxA'>
                <img src={item.slika} className='slikaA' alt='slika'/>
              </div>
          </div>
          ))}
      </div>
      <div className='productsContainer'>
        <p className='h2' style={{fontFamily:"Exo2-Medium"}}>Square Profiles Applications</p>
      </div>
      <div className='sA' style={{flexWrap:"wrap"}}>
        {squareApp.map((item,index)=>(
            <div className='okvirA' style={{ marginRight:"3%"}}>
              <div className='productBoxA'>
                <img src={item.slika} className='slikaA' alt='slika'/>
              </div>
          </div>
          ))}
      </div>
      <div className='productsContainer'>
        <p className='h2' style={{fontFamily:"Exo2-Medium"}}>Lean Tube Applications</p>
      </div>
      <div className='sA' style={{flexWrap:"wrap"}}>
        {leanPipe.map((item,index)=>(
            <div className='okvirA' style={{marginRight:"3%"}}>
              <div className='productBoxA'>
                <img src={item.slika} className='slikaA' alt='slika'/>
              </div>
          </div>
          ))}
      </div>
      <div className='productsContainer'>
        <p className='h2' style={{fontFamily:"Exo2-Medium"}}>Heavy Square Tube Applications</p>
      </div>
      <div className='sA' style={{flexWrap:"wrap"}}>
        {HeavySquare.map((item,index)=>(
            <div className='okvirA' style={{marginRight:"3%"}}>
              <div className='productBoxA'>
                <img src={item.slika} className='slikaA' alt='slika'/>
              </div>
          </div>
          ))}
      </div>
    </div>
  )
}
